module.exports = __webpack_public_path__ + "media/4-z.a101744b.wav";